import { Header } from 'components/molecules';
import ListServicesTemplate from 'components/templates/ServicesTemplate/ListServicesTemplate';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const ListServicePage = () => {
  return (
    <>
      <Header
        title="Servicios"
        subtitle="Administra tus servicios"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <ListServicesTemplate />
    </>
  );
};

export default withAuth(ListServicePage, ['ROLE_DEVELOPER'], "mayasoft");
